import React from 'react';
import Icon from '../../../components/AppIcon';

const GRAD        = 'linear-gradient(135deg, #004AAD 0%, #0082FB 100%)';
const GRAD_SHADOW = '0 4px 16px rgba(0,74,173,0.35)';

const SubmissionSuccessModal = ({ isOpen, onClose, userEmail }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 50,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, background: 'rgba(0,0,0,0.50)',
      fontFamily: 'inherit',
    }}>
      <div style={{
        background: 'var(--card, #ffffff)',
        borderRadius: 20,
        boxShadow: '0 24px 80px rgba(0,0,0,0.18)',
        maxWidth: 440, width: '100%',
        padding: '36px 32px 32px',
        animation: 'ssm-in 0.22s ease both',
      }}>
        <style>{`
          @keyframes ssm-in {
            from { opacity: 0; transform: scale(0.95) translateY(8px); }
            to   { opacity: 1; transform: scale(1)    translateY(0);   }
          }
        `}</style>

        {/* Icon */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 22 }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: 'rgba(22,163,74,0.10)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name="CheckCircle2" size={40} color="#16a34a" />
          </div>
        </div>

        {/* Heading */}
        <h2 style={{
          fontFamily: "'Sansation', sans-serif",
          fontSize: 24, fontWeight: 700,
          color: 'var(--foreground, #0f172a)',
          textAlign: 'center', margin: '0 0 20px',
          letterSpacing: '-0.01em',
        }}>
          Submission Successful!
        </h2>

        {/* Info box */}
        <div style={{
          background: 'var(--muted, #f8fafc)',
          borderRadius: 12, padding: '16px 20px', marginBottom: 24,
        }}>
          <p style={{
            fontFamily: 'inherit', fontSize: 14,
            color: 'var(--foreground, #0f172a)',
            textAlign: 'center', lineHeight: 1.65, margin: 0,
          }}>
            Free DecX Score is underway and an email on registered id will be sent once ready, ETA is 24 hours
          </p>
        </div>

        {/* Info rows */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 28 }}>
          {[
            { icon: 'Mail',      label: 'Email Notification', value: userEmail },
            { icon: 'Clock',     label: 'Estimated Time',     value: '24 hours' },
            { icon: 'BarChart3', label: "What's Next?",       value: 'Track your submission status on your dashboard' },
          ].map(({ icon, label, value }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <Icon name={icon} size={20} color="#004AAD" style={{ flexShrink: 0, marginTop: 2 }} />
              <div>
                <p style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: 600, color: 'var(--foreground, #0f172a)', margin: '0 0 2px' }}>
                  {label}
                </p>
                <p style={{ fontFamily: 'inherit', fontSize: 13, color: 'var(--muted-foreground, #64748b)', margin: 0 }}>
                  {value}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '15px 0', borderRadius: 100,
            border: 'none', cursor: 'pointer',
            background: GRAD, color: '#ffffff',
            fontSize: 15, fontWeight: 700, fontFamily: 'inherit',
            boxShadow: GRAD_SHADOW,
            transition: 'filter 0.15s, transform 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.08)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseLeave={e => { e.currentTarget.style.filter = ''; e.currentTarget.style.transform = ''; }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default SubmissionSuccessModal;